import endpoints from './endpoints'
import Vue from 'vue'
const baseURL = endpoints.baseUrl

const fetch = ({
  payload,
  url,
  data,
  method = 'post',
  mock = false
}) => {
  let requestConfig = {
    method,
    url: baseURL + url,
    body: data,
    params: payload
  }
  return {
    call: () =>
      mock
        ? Promise.resolve(mock)
        : Vue.http(requestConfig).then((response) => {
          return response
        }, (error) => {
          return error
        })
  }
}
export default fetch



// WEBPACK FOOTER //
// ./src/api/fetch.js